var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"border-l-4 border-slate-400 px-2"},[_c('div',{staticClass:"max-w-sm text-xs text-vanilla-400"},[_vm._t("default",function(){return [_c('p',{domProps:{"innerHTML":_vm._s(_vm.info)}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }